import '../../components/app/common.scss';
import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

export default function CustomEditor({onChange, parent, prop, value = ''}) {
    const editorRef = useRef(null);
    const handleChange = (e, onChange, v) => {
      e.preventDefault();
      if (parent) {
          parent[prop] = e.target.getContent();
      }
      onChange(e);
  }
    return (
      <>
        <Editor
          onInit={(evt, editor) => editorRef.current = editor}
          initialValue={value}
          onChange={(e, v) => handleChange(e, onChange, v)}
          init={{
            height: 500,
            menubar: false,
            plugins: [  'a11ychecker', 'codesample', 'advlist','advcode','advtable','autolink','checklist','export',
            'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
            'powerpaste','fullscreen','formatpainter','insertdatetime','media','table','help','wordcount'
            ],
            toolbar: 'bold italic underline |' +
            'bullist numlist | a11ycheck codesample |'+
              'table | attachment link | undo redo |',
            content_style: 'body { font-family:Inter, Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </>
    );
  }